import { createFileRoute } from '@tanstack/react-router';

import { RoomsPageComponent } from '~/page-components/rooms-page';

export const Route = createFileRoute('/rooms/')({
  component: RoomsPageComponent
});
